import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage';
import BookPage from './components/BookPage';
import BookReader from './components/BookReader';
import ErrorBoundary from './components/ErrorBoundary';
import { initializeAnalytics } from './services/analytics';

function App() {
  // Initialize analytics on app start
  React.useEffect(() => {
    initializeAnalytics();
  }, []);

  return (
    <div className="App">
      <ErrorBoundary>
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/book/:bookId" element={<BookPage />} />
            <Route path="/book/:bookId/reader" element={<BookReader />} />
            <Route path="/book/:bookId/reader/:chapterId" element={<BookReader />} />
          </Routes>
        </Router>
      </ErrorBoundary>
    </div>
  );
}

export default App;